import React, { Text , Component } from "react";
import { withRouter } from 'react-router'
import { Link } from "react-router-dom";
// import {Link} from 'react-router-dom'
import { Menu } from "semantic-ui-react";
import { AuthConsumer } from "../../AuthContext";

import Footer from "../../Footer";
import menus from "../Helpers/menus";

import colors from "../../colors";
import info from '../../info.png'
import decode from "jwt-decode";
import {
  Navbar,
  NavbarNav,
  NavbarToggler,
  Collapse,
  NavItem,
  NavLink,
  Button,
} from "mdbreact";
import HeaderCommon from "../../headerFlux";
class Layout extends Component {
  constructor(props) {
    super(props);
    console.log(props.match)
    this.state = {
      collapse: false,
      isWideEnough: false,
      dropdownOpenAbout: false,
      dropdownOpenTeams: false,
      dropdownOpenProjects: false,
      active: props.match.url === '/webgis-et' ? 'ET Home' : props.match.url === '/webgis-et/map' ? 'ET Geoportal' : props.match.url === '/webgis-et/proj-obj' ? 'Objective' : props.match.url === '/nhp-data-download' ? 'Download Products' : null,
      isOpen: false,
      etmodal: true,
    };
  }
  toggle = () => {
    this.setState({
      etmodal: !this.state.etmodal
    })
  }
  onClick = () => {
    this.setState({
      collapse: !this.state.collapse,
    });
  };
  _handleClick(menuItem) {
    this.setState({ active: menuItem });
    this.onClick()
  }
  componentDidUpdate(prevProps, prevState) {
    if (this.props.match.url !== prevProps.match.url) {
      this.setState({
        active: this.props.match.url === '/webgis-et' ? 'ET Home' : this.props.match.url === '/webgis-et/map' ? 'ET Geoportal' : this.props.match.url === '/webgis-et/proj-obj' ? 'Objective' : this.props.match.url === '/nhp-data-download' ? 'Download Products' : null,
      })
    }
  }
  render() {
    const activeStyle = { color: '#ff4411', };
    let menuList = menus.head.map((menu, key) => {
      return (
        <NavItem key={key}>
          <NavLink to={menu.path} key={key}>
            <Menu.Item
              name={menu.name}
              style={this.state.active === menu.name ? activeStyle : {}}
              // style={this.state.active === menu.name ? activeStyle : {}}
              onClick={this._handleClick.bind(this, menu.name)}
            />
          </NavLink>
        </NavItem>
      );
    });
    const childrenWithExtraProp = React.Children.map(
      this.props.children,
      (child, i) => {
        return React.cloneElement(child, {
          //this properties are available as a props in child components
          etmodal: this.state.etmodal,
          toggle: this.toggle,
          index: i
        });
      }
    );
    return (
      <div className="wrapper">
        { <HeaderCommon
          // title="Regional Evaporative Flux Monitoring System"
          title1="National Evaporative Flux Monitoring System"
          title2="Open-Path Eddy Covariance Flux Tower Dashboard"
          screentitle1="National Evaporative Flux Monitoring System"
          screentitle2="Open-Path Eddy Covariance Flux Tower Dashboard"
          bhuvanlink={true}
        /> }
        
        

        <Navbar
          dark
          expand="md"
          scrolling
          style={{ background: colors["final_header"] }}
        >
          {!this.state.isWideEnough && <NavbarToggler onClick={this.onClick} />}
          <Collapse isOpen={this.state.collapse} navbar>
            <NavbarNav left>{menuList}</NavbarNav>
            <NavbarNav right>
              <NavItem>
                <NavLink to="/webgis-et/map">
                  <Menu.Item
                    name="ET Geoportal"
                    style={
                      this.state.active === "ET Geoportal" ? activeStyle : {}
                    }
                    onClick={this._handleClick.bind(this, "ET Geoportal")}
                  />
                </NavLink>
              </NavItem>
            </NavbarNav>

            {!this.state.etmodal ? <NavItem className="content"><img src={info} style={{ width: "20px", height: "20px", cursor: "pointer" }} onClick={this.toggle} title="About" /></NavItem> : null}
          </Collapse>
        </Navbar>

        <div className="main">{childrenWithExtraProp}</div>

        <Footer />
      </div>
    );
  }
}

export default withRouter(Layout);
